module.exports = __webpack_public_path__ + "img/shelves.288f77b7.svg";